import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatePickerField = (props) => {
  const [isOpened, setIsOpened] = useState(false);

  const handleDateChange = (date) => {
    props.handleDateChange(date);
    setIsOpened(false);
  };

  return (
    <div className="relative">
      {props.label && (
        <label className="select-container__label">{props.label}</label>
      )}
      <div className="select-container">
        <DatePicker
          name={props.name}
          selected={props.selectedDate}
          onInputClick={() => setIsOpened(true)}
          onClickOutside={() => setIsOpened(false)}
          onChange={handleDateChange}
          minDate={props.minDate}
          maxDate={props.maxDate}
          open={isOpened}
          dateFormat="MM/dd/yyyy"
          readOnly
          className="w-full px-4 py-2 rounded-none flex-nowrap h-9 max-w-6rem"
        >
          <button
            onClick={() => {
              props.handleDateChange(null);
              setIsOpened(false);
            }}
            type="button"
          >
            Clear
          </button>
        </DatePicker>
      </div>
      <label className="select-container__label">mm/dd/yyyy</label>
    </div>
  );
};

export default DatePickerField;
